"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FULLY_LOADED_THRESHOLD = void 0;
const events_1 = require("../constants/events");
/** Network silence time (ms) to consider "fully loaded" */
exports.FULLY_LOADED_THRESHOLD = 2000;
/**
 * Get metrics we care about derived from the resource performance API.
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Resource_Timing_API
 */
class ResourceTimings {
    constructor() {
        /**
         * Get the "fully loaded" time, i.e., the completion time of the first
         * network request that is followed by at least 2 sec of network silence.
         *
         * If no 2-second gap is found, or if the browser doesn't support the
         * necessary resource timing properties (*cough* *cough* IE), an empty {}
         * will be returned.
         *
         * @see
         * https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming
         */
        this.getFullyLoadedTime = () => {
            // Bail if we're not in a browser environment. See PERF-802.
            if (typeof window === 'undefined')
                return {};
            const { performance: perf } = window;
            const resources = perf.getEntriesByType('resource') || [];
            if (resources.length <= 0) {
                console.warn('No resource perf records available');
                return {};
            }
            for (let i = 0; i < resources.length; i += 1) {
                const resource = resources[i];
                // undefined if out of bounds
                const nextResource = resources[i + 1];
                const nextStartTime = nextResource
                    ? nextResource.startTime
                    : perf.now();
                if (!resource.startTime || !resource.responseEnd) {
                    console.warn('Required resource perf props are not supported by', 'this browser. Fully-loaded times will not be reported.');
                    return {};
                }
                if (nextStartTime - resource.responseEnd >=
                    exports.FULLY_LOADED_THRESHOLD) {
                    this.fullyLoadedTimesFoundCount += 1;
                    return {
                        [events_1.EVENT_NAMES.FULLY_LOADED]: Math.round(resource.responseEnd),
                    };
                }
            }
            // No gap longer than threshold found, or perf API not supported
            return {};
        };
        /**
         * Get the "fully loaded" time, but only once. If called after a fully-
         * loaded time has already been returned, return {}
         */
        this.getFullyLoadedTimeOnce = () => {
            if (this.fullyLoadedTimesFoundCount < 1) {
                return this.getFullyLoadedTime();
            }
            return {};
        };
        this.fullyLoadedTimesFoundCount = 0;
    }
}
exports.default = ResourceTimings;
